import OverlayTips from "../OverlayTips";

function OpenTasksPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

OpenTasksPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle").first().find("span"), {
            messageKey: "tips.open_tasks.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        this.add($(".formbuttonpane").first(), {
            messageKey: "tips.open_tasks.filter",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 5
        });

        this.add($(".listTableTaskNameCell").eqOrLast(4), {
            messageKey: "tips.open_tasks.edit",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: -30,
            offsetY: -10
        });

        this.add($(".listbuttonpane"), {
            messageKey: "tips.open_tasks.buttons",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -5,
            offsetY: -10
        });

        this.add($(".spentTimeCell").eqOrLast(3), {
            messageKey: "tips.open_tasks.spent_time",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -15
        });
    }
});

export default OpenTasksPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/OpenTasksPageOverlayTipsManager.js